export { default } from './FriendInvitation.container';
